/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import * as _ from 'lodash';

import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { AllocationStation } from './../../../core/model/allocation-station.model';
import { ConfigService } from '../../../core/services/config.service';
import { DivisionStation } from '../../shared/model/division-station.model';
import { LmsEventDetails } from './../../../core/model/lms-event-details.model';
import { SelectItem } from 'primeng/api/selectitem';
import { SimpleChanges } from '@angular/core';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';
import { Tab } from './../../../core/model/tab.model';
import { TabService } from '../../../core/services/tab.service';
import { YardLocalSubHeader } from './../../shared/model/yard-local-sub-header.model';

/**
 * @export
 * @class YardLocalHeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-yard-local-header',
  templateUrl: './yard-local-header.component.html',
  styleUrls: ['./yard-local-header.component.scss']
})
export class YardLocalHeaderComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() lasteRefreshedTime: string;
  @Input() tab: Tab;
  @Input() tabs: Tab[];
  commonopsPicklist: any;
  divisionList: Array<SelectItem> = [];
  stationList: Array<SelectItem> = [];
  selectedDivisionName: string;
  selectedStationName: string;
  allocationStationArr: Array<AllocationStation> = [];
  configData: any;
  tabLevel: number;
  editMode: any;

  @Input() selectedDivisionStation: DivisionStation;

  @Output() loadYardLocalDataEvent = new EventEmitter<DivisionStation>();
  @Input() yardLocalSubHeader: YardLocalSubHeader;

  /**
   * Creates an instance of YardLocalHeaderComponent.
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {ConfigService} configService
   * @memberof YardLocalHeaderComponent
   */
  constructor(private staticDataStoreService: StaticDataStoreService,
    private configService: ConfigService,
    private tabService: TabService) {
    this.configData = configService.getConfigData();
    this.tabLevel = this.configData.tabIndex.topTabs;
  }

  /**
   * Changes in state of lifecycle hook.
   *
   * @memberof YardLocalHeaderComponent
   */
  ngOnChanges(changes: SimpleChanges) {
    if (!this.divisionList || (this.divisionList && this.divisionList.length <= 1) || !this.stationList || (this.stationList && this.stationList.length <= 1)) {
      this.init();
    }
    if (this.yardLocalSubHeader && this.yardLocalSubHeader.yardLocalOption === 'M') {
      this.divisionList = this.divisionList.filter((value) => {
        return value.label !== 'ALLMOW';
      });
      this.divisionList.splice(1, 0, {
        label: 'ALLMOW',
        value: 'ALLMOW'
      });

    } else {
      this.divisionList = this.divisionList.filter((value) => {
        return value.label !== 'ALLMOW';
      });
    }
    if (this.selectedDivisionStation) {
      if (this.selectedDivisionStation.division) {
        this.selectedDivisionName = this.selectedDivisionStation.division.trim().toUpperCase();
      } else {
        this.selectedDivisionName = '';
      }
      this.stationList = [];
      this.stationList.push({
        label: 'All Station',
        value: 'all'
      });

      if (this.selectedDivisionName) {
        let stationArr = this.commonopsPicklist.allocationZoneList
        .find(obj=> obj.oprZoneCode==this.selectedDivisionName);
        if (stationArr) {
          stationArr = stationArr.allocatedStationList.sort();
          // for (const allocationStation of stationArr) {
          //   this.stationList.push({
          //     label: allocationStation.allocationStation,
          //     value: allocationStation.allocationStation
          //   });
          // }
          
          for (let allocationStation of stationArr) {
            this.stationList.push({
              label: allocationStation,
              value: allocationStation
            });
          }
        }
      }
      if (this.selectedDivisionStation.allocationStation) {
        this.selectedStationName = this.selectedDivisionStation.allocationStation.trim();
      } else {
        this.selectedStationName = 'all';
      }
    }
  }

  lmsEventHandler(lmsEventDetails: LmsEventDetails) {
    this.tabService.notifyChange(lmsEventDetails);
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberof YardLocalHeaderComponent
   */
  ngOnInit() {
    this.init();
  }

  ngAfterViewInit() {
    // this.processCursorPosition();
  }

  processCursorPosition() {
    setTimeout(() => {
      const dropDownElem = document.getElementById('yardAndLocalDropDown');
      if (dropDownElem) {
        dropDownElem.focus();
      }
    }, 20);
  }

  /**
   * Invoked when change value from corridor dropdown.
   * @memberof YardLocalHeaderComponent
   */
  changeDivision() {
    this.stationList = [];
    this.stationList.push({
      label: 'All Station',
      value: 'all'
    });
    if (this.selectedDivisionName) {
      if (this.stationList && this.stationList.length > 0) {
        this.selectedStationName = this.stationList[0].value;
      }
      const stationArr = _.filter(this.allocationStationArr,
        { 'divisionMnemonic': this.selectedDivisionName });
      if (stationArr) {
        for (const allocationStation of stationArr) {
          this.stationList.push({
            label: allocationStation.allocationStation,
            value: allocationStation.allocationStation
          });
        }
      }
    }
    const divisionStation: DivisionStation = {
      division: this.selectedDivisionName,
      allocationStation: this.selectedStationName
    };
    this.loadYardLocalDataEvent.emit(divisionStation);
  }

  /**
   * Invoked when focus on division list.
   * @memberof YardLocalHeaderComponent
   */
  divisionListFocus() {
    if (!this.divisionList || (this.divisionList && this.divisionList.length <= 1)) {
      this.init();
    }
  }

  /**
 * Invoked when focus on division list.
 * @memberof YardLocalHeaderComponent
 */
  stationListFocus() {
    if (!this.stationList || (this.stationList && this.stationList.length <= 1)) {
      this.stationList = [];
      this.stationList.push({
        label: 'All Station',
        value: 'all'
      });

      if (this.selectedDivisionName) {
        const stationArr = _.filter(this.allocationStationArr,
          { 'divisionMnemonic': this.selectedDivisionName });
        if (stationArr) {
          for (const allocationStation of stationArr) {
            this.stationList.push({
              label: allocationStation.allocationStation,
              value: allocationStation.allocationStation
            });
          }
        }
      }
    }
  }

  /**
   * Invokedn when change value from station dropdown.
   * @memberof YardLocalHeaderComponent
   */
  changeStation() {
    const divisionStation: DivisionStation = {
      division: this.selectedDivisionName,
      allocationStation: this.selectedStationName
    };
    this.loadYardLocalDataEvent.emit(divisionStation);
  }

  /**
   * @memberof YardLocalHeaderComponent
   */
  refreshClick() {
    const divisionStation = {
      opr: 'refresh'
    };
    this.loadYardLocalDataEvent.emit(divisionStation);
  }

  /**
   * Set Initial data for division and station.
   * @memberof YardLocalHeaderComponent
   */
  init() {
    if (this.selectedDivisionStation) {
      if (this.selectedDivisionStation.division) {
        this.selectedDivisionName = this.selectedDivisionStation.division;
      }
      if (this.selectedDivisionStation.allocationStation) {
        this.selectedStationName = this.selectedDivisionStation.allocationStation;
      }
    }
    this.divisionList = [];
    this.stationList = [];
    this.divisionList.push({
      label: 'Select Operating Zone',
      value: ''
    });
    // this.stationList.push({
    //   label: 'All Station',
    //   value: 'all'
    // });

    if (this.yardLocalSubHeader && this.yardLocalSubHeader.yardLocalOption === 'M') {
      this.divisionList = this.divisionList.filter((value) => {
        return value.label !== 'ALLMOW';
      });
      this.divisionList.splice(1, 0, {
        label: 'ALLMOW',
        value: 'ALLMOW'
      });

    } else {
      this.divisionList = this.divisionList.filter((value) => {
        return value.label !== 'ALLMOW';
      });
    }


    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (this.commonopsPicklist && this.commonopsPicklist.allocationZoneList) {
      const zoneArr: Array<any> = this.commonopsPicklist.allocationZoneList;
      if (zoneArr) {
        for (const zone of zoneArr) {
          this.divisionList.push({
            label: zone.oprZoneCode + ' ' + zone.oprZoneName,
            value: zone.oprZoneCode
          });
        }
      }
      if (this.commonopsPicklist.masterData.allocationStationList) {
        this.allocationStationArr = this.commonopsPicklist.masterData.allocationStationList;
      }
    // if (this.commonopsPicklist && this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.divisonList) {
      // const divisionArr: Array<TerminalDivision> = this.commonopsPicklist.masterData.divisonList;
      // if (divisionArr) {
      //   for (const terminalDivision of divisionArr) {
      //     this.divisionList.push({
      //       label: terminalDivision.divisionMenmonic + ' ' + terminalDivision.divisionName,
      //       value: terminalDivision.divisionMenmonic
      //     });
      //   }
      // }
      // if (this.commonopsPicklist.masterData.allocationStationList) {
      //   this.allocationStationArr = this.commonopsPicklist.masterData.allocationStationList;
      // }
    }

    this.stationList = [];
    // this.stationList.push({
    //   label: 'All Station',
    //   value: 'all'
    // });

    if (this.selectedDivisionName) {
      let stationArr = this.commonopsPicklist.allocationZoneList
        .find(obj=> obj.oprZoneCode==this.selectedDivisionName);
        if (stationArr) {
          stationArr = stationArr.allocatedStationList.sort();
        // for (const allocationStation of stationArr) {
        //   this.stationList.push({
        //     label: allocationStation.allocationStation,
        //     value: allocationStation.allocationStation
        //   });
        // }
        
        for (let allocationStation of stationArr) {
          this.stationList.push({
            label: allocationStation,
            value: allocationStation
          });
        }
      }
    }

    // if (this.selectedDivisionName) {
    //   const stationArr = _.filter(this.allocationStationArr,
    //     { 'divisionMnemonic': this.selectedDivisionName });
    //   if (stationArr) {
    //     for (const allocationStation of stationArr) {
    //       this.stationList.push({
    //         label: allocationStation.allocationStation,
    //         value: allocationStation.allocationStation
    //       });
    //     }
    //   }
    // }
  }
}
